///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class TunnelMarkerView {
    private static readonly Z_INDEX = 1600;
    private marker: google.maps.marker.AdvancedMarkerElement;

    constructor(
        private readonly coordinates: google.maps.LatLngLiteral,
        private readonly tunnelId: number,
        private readonly color: string
    ) {}

    draw(map: google.maps.Map): void {
        if (this.marker) {
            throw new Error('Marker is defined already');
        }
        const pinElement = new google.maps.marker.PinElement({
            glyph: `${this.tunnelId}`,
            glyphColor: 'black',
            background: this.color,
            borderColor: 'transparent'
        });

        this.marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: this.coordinates,
            title: `Tunnel: ${this.tunnelId}`,
            zIndex: TunnelMarkerView.Z_INDEX,
            content: pinElement.element,
            gmpClickable: false
        });
    }

    hide(): void {
        if (!this.marker) {
            return;
        }
        this.marker.map = null;
        this.marker = undefined;
    }
}
